/** 室料金の金額表示（未設定は `-`） */
export const formatRoomRateAmount = (value: number | null | undefined): string => {
  if (value === null || value === undefined) {
    return '-'
  }
  return `¥${value.toLocaleString()}`
}
